<script>
import Hero from "@/components/Hero.vue";
import Partners from "@/components/Partners.vue";
import About from "@/components/About.vue";
import Socials from "@/components/Socials.vue";
import Easy from "@/components/Easy.vue";
import Subscrtiptions from "@/components/Subscrtiptions.vue";
import Games from "@/components/Games.vue";
import CTAbanner from "@/components/CTAbanner.vue";
import FAQ from "@/components/FAQ.vue";
import Freesub from "@/components/Freesub.vue";

export default {
    name: "Home",
    components: {Freesub, FAQ, CTAbanner, Games, Subscrtiptions, Easy, Socials, About, Partners, Hero},
}
</script>

<template>
    <section class="landing">
        <Hero></Hero>
        <Games></Games>
        <Easy></Easy>
        <Partners></Partners>
        <Socials></Socials>
        <Subscrtiptions></Subscrtiptions>
        <CTAbanner></CTAbanner>
        <FAQ></FAQ>
    </section>
</template>

<style scoped>
.landing {
    overflow: hidden;
    background: #040404;
}

@media (min-width: 320px) {

}

@media (min-width: 464px) {

}

@media (min-width: 744px) {

}

@media (min-width: 984px) {

}

@media (min-width: 1248px) {
}
</style>